import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import ButtonTypes from '../../constants/buttonTypes';
import Table from '../Table/Table';
import TableHead from '../Table/TableHead';
import TableRow from '../Table/TableRow';
import TableHeadData from '../Table/TableHeadData';
import TableBody from '../Table/TableBody';
import TableData from '../Table/TableData';

const PriceHistoryModal = ({
  visible, toggleVisible, data
}) => {
  ReactModal.setAppElement('#root');
  return (
    <ReactModal
      isOpen={visible}
      className="border-none bg-[rgba(30,30,45,.3)]"
      overlayElement={(props, contentElement) => (
        <div
          className="z-[11] fixed w-full h-full bg-[rgba(30,30,45,.3)] top-0 left-0"
        >
          {contentElement}
        </div>
      )}
    >
      <div className="absolute flex justify-center items-center w-full h-full top-0 left-0">
        <div className="h-max justify-center items-center flex flex-col min-w-[350px] z-[10]
          bg-white dark:bg-background-dark rounded-[8px] p-[30px] shadow-default
          animate__animated animate__fadeInDown animate__faster"
        >
          <div className="p-[25px]">
            <Table>
              <TableHead>
                <TableRow bordered>
                  <TableHeadData>Date</TableHeadData>
                  <TableHeadData>Old Data</TableHeadData>
                  <TableHeadData>New Date</TableHeadData>
                  <TableHeadData>Price</TableHeadData>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map(({
                  date,
                  oldPrice,
                  oldWarehouseQty,
                  newItemQty,
                  newPrice,
                  newItemPrice
                }, idx) => (
                  <TableRow key={`${[data, idx].join('_')}`}>
                    <TableData>{date}</TableData>
                    <TableData>
                      {`${oldWarehouseQty}/$${oldPrice}`}
                    </TableData>
                    <TableData>
                      {`${newItemQty}/$${newItemPrice}`}
                    </TableData>
                    <TableData>
                      {`$${newPrice}`}
                    </TableData>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <div className="flex flex-row justify-center">
            <Button
              text="Close"
              onClick={() => {
                toggleVisible();
              }}
              type={ButtonTypes.WHITE}
            />
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

PriceHistoryModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    newItemPrice: PropTypes.number,
    newItemQty: PropTypes.number,
    newPrice: PropTypes.number,
    oldPrice: PropTypes.number,
    oldWarehouseQty: PropTypes.number,
  }))
};

PriceHistoryModal.defaultProps = {
  toggleVisible: () => {},
  visible: false,
  data: []
};

export default PriceHistoryModal;
